module.exports = __webpack_public_path__ + "static/img/bg.bb1664d3.png";